export default __webpack_public_path__ + "media/zurb/img/services/services/emerging-tech-img-efddb18962d60f165e338ac1f021183f.png";